import type { SellerRef } from './SellerActions';

/** Route of the Team → Sellers tab. Both report entry points (grid card +
 *  details modal) live here, so the generator's Close returns here too. */
export const SELLERS_TAB_ROUTE = '/campaigns?view=team&teamTab=sellers';

/**
 * Report Generator URL locked to one seller. Shared by the Sellers-grid card
 * and the details-modal header so both entry points stay in sync (single
 * source of truth for the link shape). `sellerName` is a display fallback —
 * the generator re-fetches the profile itself.
 */
export const sellerReportUrl = (seller: SellerRef, sellerName?: string): string =>
  `/reports/generate?${new URLSearchParams({
    sellerId: seller.id,
    ...(sellerName ? { sellerName } : {}),
    from: SELLERS_TAB_ROUTE,
  })}`;
